import { formatDate } from 'utils/constants/functions';

export const HandoverVariables = {
  getListHandover: (params: any) => {
    const {
      page,
      page_size,
      plantId,
      teamSalesId,
      routeId,
      customerId,
      orderId,
      purchaseId,
      fromDateToDate,
      status,
    } = params;
    return {
      skip: page_size * (page - 1),
      take: page_size,
      input: {
        ...(plantId && { plantId }),
        ...(teamSalesId && { teamSalesId }),
        ...(routeId && { routeId }),
        ...(customerId && { customerId }),
        ...(orderId && { orderId }),
        ...(purchaseId && { purchaseId }),
        ...(fromDateToDate && {
          implementationStartDate: fromDateToDate[0].format(
            'YYYY-MM-DD 00:00:00',
          ),
          implementationEndDate: fromDateToDate[1].format(
            'YYYY-MM-DD 23:59:59',
          ),
        }),
        ...(status && { status }),
      },
    };
  },

  confirmHandover: (params: any) => {
    const {
      teamSalesId,
      routeId,
      customerId,
      implementationDate,
      treasurerId,
      warehouseAdminister,
      q10,
      handOverQ10,
      finalPrice,
      handOverFinalPrice,
      plantId,
    } = params;
    return {
      input: {
        ...(plantId && { plantId }),
        ...(teamSalesId && { teamSalesId }),
        ...(routeId && { routeId }),
        ...(customerId && { customerId }),
        ...(implementationDate && {
          implementationDate,
        }),
        // ...(implementationDate && {
        //   implementationDate: formatDate(
        //     implementationDate,
        //     'YYYY-MM-DD HH:mm:ss',
        //   ),
        // }),
        ...(treasurerId && { treasurerId }),
        ...(warehouseAdminister && { warehouseAdminister }),
        ...(q10 && { q10 }),
        ...(handOverQ10 && { handOverQ10 }),
        ...(finalPrice && { finalPrice }),
        ...(handOverFinalPrice && { handOverFinalPrice }),
      },
    };
  },
};
